import { FC } from 'react'
import { FaExternalLinkAlt } from 'react-icons/fa'
import { Box, Button, DarkMode, HStack, IconButton, Show, Spacer, Tooltip, useColorMode } from '@chakra-ui/react'
import { FiMoon, FiSun } from 'react-icons/fi'

export const Header: FC = () => {

    const { colorMode, toggleColorMode } = useColorMode()

    const handleOpenUrl = (url: string) => () => window.open(url, '_blank')

    return (
        <Box
            style={{
                display: 'flex',
                justifyContent: 'center',
                backgroundColor: 'var(--chakra-colors-chronicle-navy)'
            }}
            shadow='dark-lg'
        >
            <DarkMode>
            <HStack
                style={{
                    width: '100%',
                    height: '70px',
                    maxWidth: 'var(--fix-parser-base-width)',
                }}
                paddingX={4}
            >
                <Box
                    sx={{ pointerEvents: 'auto', cursor: 'pointer' }}
                    onClick={handleOpenUrl('https://chronicle.software')}
                >
                    <img
                        style={{ width: '130px', minWidth: '130px', padding: '20px 20px 20px 0' }}
                        alt="Chronicle Software"
                        src="./logo.svg"
                    />
                </Box>
                <Spacer/>
                <Tooltip
                    label={`Switch to ${colorMode === 'dark' ? 'light' : 'dark'} mode`}
                >
                    <IconButton
                        size='sm'
                        borderRadius={2}
                        aria-label='dark-light-mode-switch'
                        icon={colorMode === 'dark' ? <FiSun /> : <FiMoon />}
                        variant='ghost'
                        onClick={toggleColorMode}
                    />
                </Tooltip>
                    <HStack>
                        <Show breakpoint='(min-width: 445px)'>
                            <DarkMode>
                            <Button
                                color='white'
                                borderRadius={2}
                                variant='solid'
                                size="sm"
                                _hover={{
                                    background: "chronicle.ultramarineLight",
                                    color: 'white'
                                }}
                                onClick={handleOpenUrl('https://chronicle.software/products/fix-engine/')}
                            >
                                {'Check out Chronicle FIX'}
                                {<FaExternalLinkAlt style={{ marginLeft: '10px', fontSize: '14x' }} />}
                            </Button>
                            </DarkMode>
                        </Show>
                        <Show breakpoint='(min-width: 540px)'>
                            <Button
                                color='white'
                                borderRadius={2}
                                variant='solid'
                                size="sm"
                                _hover={{
                                    background: "chronicle.ultramarineLight",
                                    color: 'white'
                                }}
                                onClick={handleOpenUrl('https://chronicle.software/contact-us/')}
                            >
                                Contact Us
                            </Button>
                        </Show>
                    </HStack>
            </HStack>
            </DarkMode>
        </Box>
    )
}
